import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";
import { message } from "antd";
import { useState } from "react";
import { duplicateAssistant, updateAssistant } from "./service";

const template = [
  { name: "name", label: "Assistant Name", type: "text" },
  {
    name: "description",
    label: "Description",
    type: "textArea",
    style: { height: "100px" },
    description: "Describe Who the assistant is?",
  },
];

const schema = {
  name: Joi.string().required(),
  description: Joi.string().allow(null, ""),
};

const buttonInfo = {
  buttons: "2",
  primaryLabel: "Update",
  secondaryLabel: "Cancel",
};

function AssistantRename(props) {
  const {
    isOpen,
    onClose,
    assistantId,
    assistantName,
    assistantDescription,
    workspaceId,
    onSuccess,
  } = props;
  const [loading, setLoading] = useState(false);

  const assistantData = {
    name: assistantName,
    description: assistantDescription,
  };

  const handleRename = async (data) => {
    setLoading(true);
    message.loading("Updating..");

    try {
      const response = await updateAssistant({
        projectId: workspaceId,
        assistantId,
        payload: data,
      });

      if (response.status === 200) {
        const assistant = response.data;
        message.destroy();
        message.success("Assistant Updated");
        onSuccess(assistant._id);
        onClose();
      }
    } catch (e) {
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to update assistant");
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Edit Assistant</DialogTitle>
      <DialogBody>
        <Form
          inputField={assistantData}
          buttonInfo={buttonInfo}
          onSubmit={handleRename}
          loading={loading}
          setLoading={setLoading}
          handleSecondary={onClose}
          template={template}
          schema={schema}
        />
      </DialogBody>
    </Dialog>
  );
}

export { AssistantRename };
